/**
 * Timing constants used throughout the application
 */

// Redirect delays
export const REDIRECT_DELAY_SECONDS = 5; // 5 seconds for not-found page auto-redirect
